import Image from "next/image";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { memo } from "react";
import ArrowLink from "@/components/ui/arrow-link";
import { Typography } from "@/components/ui/typography";

export type ServiceTrustCardProps = {
  title: string;
  description: string;
  href?: string;
  linkLabel?: string;
  target?: string;
  rel?: string;
} & React.ComponentProps<"div">;

const ServiceTrustCard = ({
  title,
  description,
  href = "#",
  linkLabel,
  target,
  rel,
  className,
}: ServiceTrustCardProps) => {
  return (
    <div
      className={cn(
        "flex flex-col border bg-white border-neutral-200 rounded-3xl overflow-hidden lg:rounded-2xl lg:border-0",

        className
      )}
    >
      <div className="flex flex-col p-5 flex-auto min-w-0">
        <div className="grid grid-cols-1 gap-3">
          <Typography
            variant="titleMd"
            className="font-semibold lg:leading-[150%]"
          >
            <h4>{title}</h4>
          </Typography>
          <div className="text-base leading-[160%] lg:text-sm lg:leading-[150%]">
            <p>{description}</p>
          </div>
        </div>
        <div className="mt-auto pt-[23] pb-[11] sm:pt-3 sm:pb-0 flex">
          <ArrowLink href={href} target={target} rel={rel}>
            {linkLabel}
          </ArrowLink>
        </div>
      </div>
    </div>
  );
};
export default memo(ServiceTrustCard);
